import React, { Component } from 'react';
import { Context } from "context";
import PropTypes from 'prop-types';

import styles from 'components/toasts/toasts.module.scss';

/**
 * Message Banner component
 * @param {Object} props
 */
export default class Toast extends Component{
    static contextType = Context;

    ok = () => {
        this.props.callBack(true);
        this.context.unsetToast(this.props.id);
    };

    cancel = () => {
        this.props.callBack(false);
        this.context.unsetToast(this.props.id);
    };

    render() {
        return (
            <div className={`${styles.toast} bg${this.props.bgColour} ${this.props.type} animated fadeInDown`}>
                <div>
                    <p>{this.props.message}</p>
                    {this.props.type !== 'confirm' && this.props.closeable &&
                        <img
                            src={require(`images/icons/cross-dark.svg`)}
                            alt="close"
                            onClick={() => this.context.unsetToast(this.props.id)}
                        />
                    }
                </div>
                {this.props.type === 'confirm' &&
                    <div>
                        {this.props.cancelable && <a className={`${styles.btn} btn`} onClick={this.cancel}>Cancel</a>}
                        <a className={`${styles.btn} btn`} onClick={this.ok}>Ok</a>
                    </div>
                }
            </div>
        )
    }
}

Toast.propTypes = {
    bgColour: PropTypes.string,
    message: PropTypes.string,
    id: PropTypes.string,
    callBack: PropTypes.func,
    closeable: PropTypes.bool
};
